import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { SubItemService } from "src/app/core/services/business/service/sub-item.service";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { RenommerFichier } from "src/app/core/services/business/model/renommer-fichier";

@Component({
  selector: "app-renommer-fichier",
  templateUrl: "./renommer-fichier.component.html",
  styleUrls: ["./renommer-fichier.component.scss"],
})
export class RenommerFichierComponent implements OnInit {
  @Input() subitemId;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  subitem: SubItem;

  renommerFichier: RenommerFichier = new RenommerFichier();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _gestionFichierService: GestionFichierService,
    private _subItemService: SubItemService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      fileName: [null, Validators.compose([Validators.required])],
      displayName: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getSubItemById(this.subitemId);
  }

  getSubItemById(subitemId) {
    this._subItemService.findById(subitemId).subscribe(
      (data) => {
        this.subitem = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.spinner.show();

    this.renommerFichier.subItemId = this.subitemId;
    this.renommerFichier.fileName = this.form2.value.fileName;
    this.renommerFichier.displayName = this.form2.value.displayName;

    this._gestionFichierService
      .rename(this.renommerFichier)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.errorMessage = error.error.message;
          this.spinner.hide();
        }
      );
  }
}
